import React, {SyntheticEvent} from "react";
import {Participant} from "@nextlot/core/webcast/data/data_types_definitions";
import {AuctionsManager} from "@nextlot/core/webcast";
import {TaggedLogger} from "@nextlot/core/utilities";

const _logger = TaggedLogger.get('ClerkBiddersListTabContentCmp');

type ParticipantsType = {
  mapByUserId?: Map<number, Participant>,
  onlineBidders: Array<Participant>,
  offlineBidders: Array<Participant>,
  onlineViewers: Array<Participant>,
  offlineViewers: Array<Participant>,
};

type RootCmpPropsType = {
  participants: ParticipantsType,

  openChatRoom: (roomId: number) => void,
};


export default class ClerkBiddersListTabContentCmp extends React.Component<RootCmpPropsType, { filteredBidders: Array<any> }> {


  constructor(props) {
    super(props);

    this.state = {
      filteredBidders: []
    };
  }


  handleClick_ParticipantChat = (participant: Participant):React.MouseEventHandler => (evt) => {
    this.props.openChatRoom(participant.userId);
  };

  handleClick_ParticipantKick = (participant: Participant):React.MouseEventHandler => (evt) => {
    _logger.debug('.handleClick_ParticipantKick: ', participant, '  -- event:', evt)
    if (evt.shiftKey) {
      AuctionsManager.currentWebcastAuctionHandler.controller.sendKickParticipant(participant.userId)
    }
  };


  handleOnChange = (event) => {
    const participants: ParticipantsType = this.props.participants;
    const allBidders = participants.onlineBidders.concat(participants.offlineBidders);
    const filteredBidders = allBidders.map(bidder => bidder).filter(b => b.bidderNo.startsWith(event.target.value));

    if (event.target.value.length === 0) {
      this.setState({
        filteredBidders: []
      });
    }

    if (event.target.value.length > 0) {
      if (filteredBidders.length === 0) {
        this.setState({
          filteredBidders: null
        });
      }
      else {
        this.setState({
          filteredBidders: filteredBidders
        });
      }
    }
  };


  _renderParticipantsList(participantsList, online) {
    if (participantsList && participantsList.length) {
      return participantsList.map((p) => {
        return (
          <div key={p.userId} className={`participants-list__list-item ${online ? 'online' : 'offline'}`}>
            <div className="status">&#8226;</div>
            <div className="label"
                 onClick={this.handleClick_ParticipantChat(p)}>{p.bidderNo}{p.bidderLabel ? ` / ${p.bidderLabel}` : ''}</div>
            <div className="actions">
              <span className="action chat" onClick={this.handleClick_ParticipantChat(p)}>
                  <i className="fa-regular fa-messages" />
              </span>
              <span className="action ban" onDoubleClick={this.handleClick_ParticipantKick(p)}>
                  <i className="fa-regular fa-user-slash" />
              </span>
            </div>
          </div>
        )
      })
    }
    else {
      return null;
    }
  }


  render() {
    const participants: ParticipantsType = this.props.participants;

    const sortedOnlineBidders = participants.onlineBidders
      .map(onlineBidder => onlineBidder)
      .sort((a, b) => parseInt(a.bidderNo) < parseInt(b.bidderNo) ? -1 : 1);
    const sortedOfflineBidders = participants.offlineBidders
      .map(offlineBidder => offlineBidder)
      .sort((a, b) => parseInt(a.bidderNo) < parseInt(b.bidderNo) ? -1 : 1);
    const sortedOnlineViewers = participants.onlineViewers
      .map(onlineViewer => onlineViewer)
      .sort((a, b) => parseInt(a.bidderNo) > parseInt(b.bidderNo) ? -1 : 1);
    const sortedOfflineViewers = participants.offlineViewers
      .map(offlineViewer => offlineViewer)
      .sort((a, b) => parseInt(a.bidderNo) > parseInt(b.bidderNo) ? -1 : 1);
    const sortedFilteredBidders = this.state.filteredBidders && this.state.filteredBidders
      .map(bidder => bidder)
      .sort((a, b) => parseInt(a.bidderNo) < parseInt(b.bidderNo) ? -1 : 1);


    if (participants.onlineBidders) {
      return (
        <div className="clerk-bidders-list-tab-container">
          <div className="participants-search-line">
            <span>Search bidder by #</span>
            <input className="participants-search-input ms-2" type="text"
                   onChange={this.handleOnChange.bind(this)} />
          </div>
          {this.state.filteredBidders
            ? (<div className="participants-list-container">

                <div className="participants-list__scrollable-container">

                  <div className="participants-list__list-item-header">
                    <strong>Bidders</strong> (<strong>online: {participants.onlineBidders.length}</strong> /
                    total: {participants.onlineBidders.length + participants.offlineBidders.length})
                  </div>

                  {this.state.filteredBidders.length > 0
                    ?
                    this._renderParticipantsList(sortedFilteredBidders, true)
                    :
                    (<div>
                      {this._renderParticipantsList(sortedOnlineBidders, true)}
                      <hr />
                      {this._renderParticipantsList(sortedOfflineBidders, false)}
                    </div>)
                  }

                  <div className="participants-list__list-item-header">
                    <strong>Viewers</strong> (<strong>online: {participants.onlineViewers.length}</strong> /
                    total: {participants.onlineViewers.length + participants.offlineViewers.length})
                  </div>

                  {this._renderParticipantsList(sortedOnlineViewers, true)}

                  <hr />

                  {this._renderParticipantsList(sortedOfflineViewers, false)}
                </div>

              </div>

            )
            : <p className="ps-2">No bidder found.</p>
          }
        </div>
      )
    }
    else {
      return null;
    }
  }
}
